/* GameTip — the canonical tooltip system (Edward 2026-06-11).

   Import from here going forward. The visual shell (panel + tap-toggle host)
   now physically lives HERE — ./CombatTooltip.jsx + the .combat-tt__* base
   rules in GameTip.css — relocated from CombatPlayerbar / CombatStatusRails
   on 2026-06-12 (tooltip-canon kill-list item 7). The legacy .combat-tt__*
   class NAMES are retained for now; renaming is a separate, deferred
   kill-list pass.

   Spec: wiki/decisions/2026-06-11-tooltip-canon.md */

export {
  default as GameTip,
  CombatTooltipPanel as GameTipPanel,
  TooltipToggleHost as GameTipHost,
} from './CombatTooltip';
export { MECH, MechGlyph, StatRow, statsToText } from './glyphs';
export { renderStatusText } from '../CombatPlayerbar/statusWordGlyphs';
